import React from "react";

export function DeletePanel({ folder, onConfirm, onCancel }) {
  return (
    <div style={{ padding: "1rem", color: "#333" }}>
      <h3 style={{ color: "#b00020" }}>Delete Folder</h3>

      <p>
        Are you sure you want to delete the folder:
        <strong> {folder} </strong>?
      </p>

      <p>This action cannot be undone.</p>

      <div style={{ display: "flex", marginTop: "1rem", gap: "10px" }}>
        <button
          style={{
            padding: "8px 14px",
            background: "#b00020",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer"
          }}
          onClick={onConfirm}
        >
          Delete
        </button>

        <button
          style={{
            padding: "8px 14px",
            background: "#ccc",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer"
          }}
          onClick={onCancel}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
